
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      showModal: false,
    }
  },

  computed: {
    size() {
      return this.data.image_size?.value
    },
  },
}
